(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bear-affiliate-wrapper"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCustomBearAffiliate(container) {
      // 局部作用域内实现平滑滚动，避免污染全局 html { scroll-behavior: smooth; }
      const heroBtn = container.querySelector('.custom-bear-affiliate-btn-primary');
      if (!heroBtn) return;
      
      heroBtn.addEventListener('click', function(e) {
        const targetAttr = this.getAttribute('href');
        if (targetAttr && targetAttr.startsWith('#')) {
          const targetId = targetAttr.substring(1);
          const targetEl = container.querySelector('#' + targetId);
          if (targetEl) {
            e.preventDefault();
            targetEl.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.custom-bear-affiliate-wrapper').forEach(initCustomBearAffiliate);
    });

    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('.custom-bear-affiliate-wrapper');
      if (container) initCustomBearAffiliate(container);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
